module.exports = __webpack_public_path__ + "img/refresh-white.d1e2b349.svg";